import { ComponentSingleStyleConfig, CSSObject, theme } from '@chakra-ui/react';
import { getDarkColor } from '../darkMode';

export const Link: ComponentSingleStyleConfig = {
  baseStyle: ({ colorMode }) => ({
    color: colorMode === 'light' ? 'blue.600' : 'blue.400',
    fontWeight: 'semibold',
  }),
};
